import { render, staticRenderFns } from "./motivoDeclinacion.vue?vue&type=template&id=f55780b6&"
import script from "./motivoDeclinacion.vue?vue&type=script&lang=js&"
export * from "./motivoDeclinacion.vue?vue&type=script&lang=js&"
import style0 from "./motivoDeclinacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports